export function unmask(val) {
  return val.replace(/\D+/g, '');
}

export function numberUnmask(val) {
  return val.match(/\d+/g).join('');
}
